<script>
import Notification from '../../reUse/Notification.vue';
import DropDown from '../../reUse/DropDown.vue';
export default {
  components: {
    Notification,
    DropDown,
  },
  emits: ['backToAdmin'],
  data() {
    return {
      prikaz: 'vnos',
      izbranoLetalisceId: '',
      izbranoLetalisceNaziv: '',
      steviloLetal: '',
      steviloKlubov: '',
      datumTrajanja: '',
      dLetalisca: false,
      letalisca: [],
      licence: [],
      text: '',
      types: '',
      ShowNoti: false,
      idIzbrisa: '',
      idUredi: '',
    }
  },
  mounted() {
    this.GetLetalisca();
    this.GetLicence();
  },
  computed: {
    jeObrazecVeljavno() {
      return this.izbranoLetalisceId !== '' &&
          this.steviloLetal > 0 &&
          this.steviloKlubov > 0 &&
          this.datumTrajanja !== '';
    }
  },
  methods: {
    GetLetalisca() {
      axios.post('./api/urednik/letalisca/beri/', {withCredentials: true}).then((response) => {
        this.letalisca = response.data.podatki || [];
      }).catch((napaka) => {
        this.text = "Napaka pri pridobivanju letališč: " + (napaka.response?.data?.napaka || napaka.message);
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    selectLetalisceDropDown(id) {
      this.izbranoLetalisceId = id;
      const letalisceObj = this.letalisca.find(l => l.id === id);
      if (letalisceObj) {
        this.izbranoLetalisceNaziv = letalisceObj.naziv;
      }
      this.dLetalisca = false;
    },
    urediLicenco(id) {
      const licenca = this.licence.find(l => l.id === id);
      if (licenca) {
        this.idUredi = id;
        this.izbranoLetalisceId = licenca.id_letalisca;
        const letalisceObj = this.letalisca.find(l => l.id === licenca.id_letalisca);
        if (letalisceObj) {
          this.izbranoLetalisceNaziv = letalisceObj.naziv;
        }
        this.steviloLetal = licenca.st_letal;
        this.steviloKlubov = licenca.st_klubov;
        this.datumTrajanja = licenca.trajanje;
        this.prikaz = 'vnos';
      }
    },
    GetLicence() {
      axios.post('./api/nastavitve/licence/izpis/', {}, {withCredentials: true}).then((response) => {
        this.licence = response.data.licence || [];
      }).catch((napaka) => {
        this.text = "Napaka pri pridobivanju licenc: " + (napaka.response?.data?.napaka || napaka.message);
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    VnesiLicenco() {
      if (!this.jeObrazecVeljavno) {
        this.text = "Prosim izpolni vsa polja!";
        this.types = "Napaka";
        this.ShowNoti = true;
        return;
      }

      const podvojenaLicenca = this.licence.filter((licenca) => {
        const istoLetalisce = Number(licenca.id_letalisca) === Number(this.izbranoLetalisceId);
        if (!istoLetalisce) return false;

        if (!this.idUredi) return true;
        return Number(licenca.id) !== Number(this.idUredi);
      }).length > 0;

      if (podvojenaLicenca) {
        this.text = "Licenca za izbrano letališče že obstaja.";
        this.types = "Napaka";
        this.ShowNoti = true;
        return;
      }

      var podatki = new URLSearchParams();
      podatki.append('letalisceId', this.izbranoLetalisceId);
      podatki.append('steviloLetal', this.steviloLetal);
      podatki.append('steviloKlubov', this.steviloKlubov);
      podatki.append('datumTrajanja', this.datumTrajanja);

      const endpoint = this.idUredi ? './api/nastavitve/licence/uredi/' : './api/nastavitve/licence/vnos/';
      if (this.idUredi) {
        podatki.append('id', this.idUredi);
      }

      axios.post(endpoint, podatki, {withCredentials: true}).then((response) => {
        this.text = response.data.sporocilo || (this.idUredi ? "Licenca uspešno posodobljena!" : "Licenca uspešno dodana!");
        this.types = "Uspešno";
        this.ShowNoti = true;
        this.PocistiObrazec();
        this.GetLicence();
        this.prikaz = 'seznam';
      }).catch((napaka) => {
        this.text = "Napaka pri shranjevanju licence: " + (napaka.response?.data?.napaka || napaka.message);
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    PocistiObrazec() {
      this.izbranoLetalisceId = '';
      this.izbranoLetalisceNaziv = '';
      this.steviloLetal = '';
      this.steviloKlubov = '';
      this.datumTrajanja = '';
      this.idUredi = '';
      this.dLetalisca = false;
    },
    potrdiIzbris(id) {
      this.idIzbrisa = id;
      this.text = 'Ali res želite pobrisati to licenco?';
      this.types = "Vprašanje";
      this.ShowNoti = true;
    },
    izbrisiLicenco() {
      var podatki = new URLSearchParams();
      podatki.append('id', this.idIzbrisa);
      axios.post('./api/nastavitve/licence/brisi/', podatki, {withCredentials: true}).then((response) => {
        this.text = "Licenca uspešno izbrisana";
        this.types = "Uspešno";
        this.ShowNoti = true;
        this.GetLicence();
        this.idIzbrisa = '';
      }).catch((napaka) => {
        this.text = "Napaka pri brisanju licence: " + (napaka.response?.data?.napaka || napaka.message);
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr + 'T00:00:00');
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
  }
}
</script>
<template>
  <div class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">{{ idUredi ? 'Uredi licenco' : 'Vnos licenc' }}</h1>
        </div>

        <!-- Navigation Tabs -->
        <div class="header-section header-right">
          <div class="nav-tabs">
            <button class="nav-tab" :class="{'active': prikaz === 'vnos'}" @click="prikaz = 'vnos'">
              <i class="fas fa-edit"></i>
              <span>Vnos</span>
            </button>
            <button class="nav-tab" :class="{'active bg-rdeca': prikaz === 'seznam'}" @click="prikaz = 'seznam'">
              <i class="fas fa-list"></i>
              <span>Seznam</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- VNOS VIEW -->
  <div v-if="prikaz === 'vnos'" class="container p-2">
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false" />
    </Transition>
    <form @submit.prevent="VnesiLicenco()">
      <div class="col-12">
        <div class="container p-2">
          <div class="label-dropdown" for="letalisceSelect">Letališče <button v-if="izbranoLetalisceNaziv !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="izbranoLetalisceId = ''; izbranoLetalisceNaziv = ''">Izbriši izbiro</button></div>
          <div class="drop-down-icon text-black" @click.prevent="dLetalisca = !dLetalisca">
            <i v-show="!dLetalisca" class="fas fa-chevron-right"></i>
            <i v-show="dLetalisca" class="fas fa-chevron-down"></i>
          </div>
          <button class="input border-0 rounded-4 p-2 fs-5" type="button" id="letalisceSelect" @click.prevent="dLetalisca = !dLetalisca" style="text-align: left;">{{ izbranoLetalisceNaziv || 'Izberi letališče' }}</button>
          <transition name="fade">
            <drop-down @letalisca="selectLetalisceDropDown" :data="letalisca" type="letalisca" class="drop-down-btn" v-if="dLetalisca" />
          </transition>
        </div>

        <div class="container p-2">
          <div class="label-date col-6 p-2" for="steviloLetalInput">Število letal</div>
          <input id="steviloLetalInput" type="number" class="input border-0 rounded-4 p-2 fs-5" v-model.number="steviloLetal" min="1" placeholder="Vnesi število letal" required>
        </div>

        <div class="container p-2">
          <div class="label-date col-6 p-2" for="steviloKlubovInput">Število klubov</div>
          <input id="steviloKlubovInput" type="number" class="input border-0 rounded-4 p-2 fs-5" v-model.number="steviloKlubov" min="1" placeholder="Vnesi število klubov" required>
        </div>

        <div class="container p-2">
          <div class="label-date col-6 p-2" for="datumTrajanjaInput">Datum trajanja</div>
          <input id="datumTrajanjaInput" type="date" class="input border-0 rounded-4 p-2 fs-5" v-model="datumTrajanja" required>
        </div>
      </div>

      <div class='col-12'>
        <div class="container p-2">
          <button type="submit" class="btn btn-primary rounded-pill btn-add col-12" :disabled="!jeObrazecVeljavno">{{ idUredi ? 'Posodobi licenco' : 'Shrani licenco' }}</button>
        </div>
      </div>

      <div class='col-12'>
        <div class="container p-2">
          <button type="button" @click.prevent="PocistiObrazec()" class="btn btn-outline-secondary rounded-pill col-12">Počisti</button>
        </div>
      </div>
    </form>
    <div class='col-12 p-5'></div>
  </div>

  <!-- SEZNAM VIEW -->
  <div v-else class='container p-4'>
    <Transition name="fade">
      <Notification
          v-if="ShowNoti"
          :message="this.text"
          :type="this.types"
          @da="izbrisiLicenco"
          @ne="idIzbrisa=''"
          @closeNotification="idIzbrisa=''" />
    </Transition>
    <div class='table-responsive col-md-12'>
      <table class="table table-dark table-striped">
        <thead>
        <tr>
          <th>Letališče</th>
          <th>ICAO</th>
          <th>Letal</th>
          <th>Klubov</th>
          <th>Trajanje</th>
          <th>Akcije</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for='licenca in licence' :key="licenca.id">
          <td>{{licenca.naziv}}</td>
          <td>{{licenca.icao}}</td>
          <td>{{licenca.st_letal}}</td>
          <td>{{licenca.st_klubov}}</td>
          <td>{{formatDate(licenca.trajanje)}}</td>
          <td>
            <button class='btn btn-sm btn-outline-primary me-2' @click.prevent="urediLicenco(licenca.id)">
              <i class="fas fa-edit"></i>
            </button>
            <button class='btn btn-sm btn-outline-danger' @click.prevent="potrdiIzbris(licenca.id)">
              <i class="fas fa-trash"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <!-- ODMIK OD CAPTCHE -->
    <div class='col-12 p-5'></div>
  </div>
</template>